import React, { useEffect, useState, useCallback, useRef } from "react";
import { 
  Divider, 
  Backdrop, 
  CircularProgress, 
  Button, 
  Typography, 
  Modal, 
  CardHeader, 
  IconButton, 
  Box 
} from "@mui/material";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Sidebar } from "primereact/sidebar";
import { Toast } from "primereact/toast";
import CloseIcon from '@mui/icons-material/Close';
import OurLayouts from "../Layouts";
import ProfileImage from "../../assets/images/ProfileImage.svg";
import profileServices from "../../services/profileScreen/profileServices";
import apiService from "../../services/apiservice";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import "../../App.css";

const GENDER_OPTIONS = [
  { name: "Male", code: "M" },
  { name: "Female", code: "F" },
];

const DEFAULT_USER_DATA = {
  id: "",
  code: "",
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  gender: "",
  dob: "",
  qualification: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  country: "",
  pinCode: "",
  salutation: "",
  speciality: "",
  registrationNo: "",
  maritalStatus: "",
  aboutMe: "",
  isHospitalManagement: false,
  mciverification: false,
  isApproved: false,
  photo: "",
  photoName: ""
};

const ProfileScreen = () => {
  const history = useHistory();
  const toast = useRef(null);
  
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState(DEFAULT_USER_DATA);
  const [loading, setLoading] = useState(false);
  const [termsAccept, setTermsAccept] = useState(true);
  const [termsView, setTermsView] = useState(false);
  const [policyAccept, setPolicyAccept] = useState(true);
  const [privacyView, setPrivacyView] = useState(false);
  const [consentVersionT, setConsentVersionT] = useState(null);
  const [consentVersionP, setConsentVersionP] = useState(null);
  
  const userObj = JSON.parse(localStorage.getItem("loginObj") || "{}");
  const testParam = userObj.user?.code;
  const userRoleName = userObj.roleName || '';

  const formatDate = useCallback((date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }, []);

  const parseDate = useCallback((dateString) => {
    if (!dateString) return null;
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }, []);

  const handleUserDataChange = useCallback((name, value) => {
    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const toggleSidebar = useCallback(() => {
    setVisible(prev => !prev);
  }, []);

  const cancelProfile = useCallback(() => {
    globalThis.location.href = "/dashboard";
  }, []);

  const onConsentAgree = useCallback(async () => {
    if (!consentVersionP || !consentVersionT || !userObj.user?.code) return;

    const payload = {
      createdBy: userObj.user.code,
      createdDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      modifiedBy: userObj.user.code,
      modifiedDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      privacyPolicyConsent: policyAccept ? 1 : 0,
      sourceChannel: "LB",
      status: 1,
      termsAndConditionConsent: termsAccept ? 1 : 0,
      type: "S",
      userId: userObj.user.code,
      privacyVersionNumber: consentVersionP.versionNumber,
      tcVersionNumber: consentVersionT.versionNumber
    };

    try {
      const res = await apiService.userConsentPost(payload);
      if (res.data === 1) {
        history.push('/');
      }
    } catch (error) {
      console.error("Consent update failed:", error);
    }
  }, [policyAccept, termsAccept, consentVersionP, consentVersionT, userObj, history]);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!testParam) return;
      
      setLoading(true);
      try {
        const res = await profileServices.getDataAPI(testParam);
        setUserData(res?.data?.successObject || DEFAULT_USER_DATA);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user data", error);
        setLoading(false);
      }
    };

    fetchUserData();
  }, [testParam]);

  useEffect(() => {
    const fetchConsentVersions = async () => {
      try {
        const result = await apiService.getUserConsent();
        const policy = result.data.find(val => val.constentName === "PrivacyPolicy");
        const terms = result.data.find(val => val.constentName === "TermsAndCondition");
        setConsentVersionP(policy || null);
        setConsentVersionT(terms || null);
      } catch (error) {
        console.error("Error fetching consent versions:", error);
      }
    };

    fetchConsentVersions();
  }, []);

  const handleTermsClick = useCallback(() => {
    setTermsView(true);
  }, []);

  const handlePrivacyClick = useCallback(() => {
    setPrivacyView(true);
  }, []);

  const renderSidebar = () => (
    <Sidebar 
      style={{ width: '588px' }} 
      visible={visible} 
      onHide={() => setVisible(false)} 
      position="right"
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem', borderBottom: '1px solid #ccc' }}>
        <div className="font-poppins text-base font-semibold leading-6 tracking-normal text-left">Update Consent</div>
        <Button 
          icon="pi pi-times" 
          onClick={() => setVisible(false)} 
          className="p-button-text p-button-danger p-button-sm" 
        />
      </div>

      <div className="bg-white p-5">
        <p className="text-2xl font-semibold mb-8">
          <b>Please Accept Terms of use and Privacy Policy to continue</b>
        </p>
        <div className='mr-20'>
          <div className="flex mt-4">
        <div className="flex space-x-2">
  <input
    type="checkbox"
    onChange={(e) => setTermsAccept(e.target.checked)}
    className="form-radio"
    name="accountType"
    value="personal"
    checked={termsAccept}
    id="terms-checkbox"
  />

  <label
    htmlFor="terms-checkbox"
    className="text-xs font-medium font-montserrat flex items-center"
  >
    <button
      type="button"
      className="text-brand-primary font-medium text-sm underline bg-transparent border-none p-0"
      onClick={handleTermsClick}
      aria-label="View Terms and conditions"
    >
      Terms and conditions
    </button>
  </label>
</div>

          </div>
        <div className="flex mt-4">
  <div className="flex space-x-2">
    <input
      type="checkbox"
      onChange={(e) => setPolicyAccept(e.target.checked)}
      className="form-radio"
      name="accountType"
      value="personal"
      checked={policyAccept}
      id="privacy-checkbox"
    />

    <label
      htmlFor="privacy-checkbox"
      className="text-xs font-medium font-montserrat flex items-center"
    >
      <button
        type="button"
        className="text-brand-primary font-medium text-sm underline bg-transparent border-none p-0"
        onClick={handlePrivacyClick}
        aria-label="View Privacy policy"
      >
        Privacy policy
      </button>
    </label>
  </div>
</div>

        </div>
      </div>

      <div className='mt-32'>
        <button 
          className="w-full h-9 bg-[#004172] text-white rounded-md"
          onClick={onConsentAgree}
        >
          Update
        </button>
      </div>
    </Sidebar>
  );

  const renderConsentModal = (open, onClose, title, consentFile) => (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ width: 1000, height: 600, margin: 'auto', marginTop: '5%' }}>
        <div className='bg-white'>
          <CardHeader
            title={
              <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                {title}
              </Typography>
            }
            action={
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            }
            style={{
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0',
            }}
          />
          <Divider />
          {consentFile && (
            <div className="bg-white">
              <iframe 
                src={`${process.env.REACT_APP_IMAGE_URL || ''}${consentFile}`}
                height="450px"
                width="900px"
                title={title}
              />
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );

  const getGenderDisplayValue = (genderCode) => {
    if (!genderCode) return "";
    const genderOption = GENDER_OPTIONS.find(option => option.code === genderCode);
    return genderOption ? genderOption.name : genderCode;
  };

  const renderInputComponent = (type, displayValue, value, name, label, disabled) => {
    if (type === "dropdown") {
      return (
        <Dropdown
          value={displayValue}
          options={GENDER_OPTIONS}
          optionLabel="name"
          placeholder={`Select ${label}`}
          disabled={disabled}
          className="mt-1 w-60 h-10 border rounded border-solid border-[#E2E2E2] box-border p-inputtext"
        />
      );
    }
    
    if (type === "date") {
      return (
        <Calendar
          value={parseDate(value)}
          onChange={(e) => handleUserDataChange(name, formatDate(e.value))}
          showIcon
          disabled={disabled}
          className="w-60 h-10 mt-1 border rounded border-solid border-[#E2E2E2] box-border p-inputtext"
        />
      );
    }
    
    return (
      <InputText
        id={name}
        value={displayValue}
        onChange={(e) => handleUserDataChange(name, e.target.value)}
        disabled={disabled}
        className="mt-1 w-60 h-10 border rounded border-solid border-[#E2E2E2] box-border p-inputtext"
      />
    );
  };
  const renderInputField = (label, value, name, disabled = false, type = "text") => {
    let displayValue = value;
    
    if (type === "dropdown" && name === "gender") {
      displayValue = getGenderDisplayValue(value);
    } else if (name === "roleName") {
      displayValue = userRoleName;
    }
    return (
      <div className="pt-10 pl-6">
        <label htmlFor={name} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {renderInputComponent(type, displayValue, value, name, label, disabled)}
      </div>
    );
  };


  return (
    <OurLayouts>
      <Backdrop
        sx={{ color: "#FFFFFF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress size={80} color="inherit" />
      </Backdrop>
      <Toast ref={toast} />
      
      {renderSidebar()}
      
      <div className="flex flex-col h-screen w-screen mt-8">
        <div className="flex flex-row">
          <Button icon="pi pi-bars" onClick={toggleSidebar} />
          <div className="mt-20 ml-8">
            <h1 className="font-bold text-2xl leading-6 tracking-normal text-left text-[#262626]">
              My Profile
            </h1>
            
            <div className="w-full h-[118px] mt-8 ml-8 rounded-[5px] bg-[#FFFFFF] flex flex-row">
              <div className="flex flex-row w-full">
                <img src={ProfileImage} alt="Profile" className="p-3 cursor-pointer" />
                <div className="flex flex-col">
                  <h1 className="font-bold text-2xl leading-6 tracking-normal text-left text-[#262626] pt-4 pl-6 pb-2">
                    {userData.firstName} {userData.lastName}
                  </h1>
                  <h1 className="font-normal text-lg tracking-normal text-left text-[#262626] pl-8">
                    {userData.mobile}
                  </h1>
                </div>
                <button
                  className="w-40 h-10 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md ml-auto mt-7"
                  onClick={() => setVisible(true)}
                >
                  Update Consent
                </button>
              </div>
            </div>
            
            <div 
              className="w-full mt-8 ml-8 rounded-[5px]" 
              style={{ boxShadow: "0px 8px 25px 0px rgba(0, 0, 0, 0.06)" }}
            >
              <h1 className="font-bold text-2xl leading-6 tracking-normal text-left text-[#262626] pt-10 pl-6 pb-4">
                Personal Information
              </h1>
              <Divider style={{ marginRight: "20px", marginLeft: "20px" }} />
              
              <div className="flex flex-col">
                <div className="flex flex-row">
                  {renderInputField("User Id", userData.code, "code", true)}
                  {renderInputField("Salutation", userData.salutation, "salutation", true)}
                  {renderInputField("First Name", userData.firstName, "firstName", true)}
                  {renderInputField("Last Name", userData.lastName, "lastName", true)}
                </div>
                
                <div className="flex flex-row">
                  {renderInputField("Profession", userRoleName, "roleName", true)}
                  {renderInputField("Date of Birth", userData.dob, "dob", true, "date")}
                  {renderInputField("Email Id", userData.email, "email", true)}
                  {renderInputField("Gender", userData.gender, "gender", true, "dropdown")}
                </div>
                
                <div className="flex flex-row">
                  {renderInputField("Mobile Number", userData.mobile, "mobile", true)}
                  {renderInputField("Qualifications", userData.qualification, "qualification", true)}
                  {renderInputField("Address 1", userData.address1, "address1", true)}
                  {renderInputField("Address 2", userData.address2, "address2", true)}
                </div>
                
                <div className="flex flex-row">
                  {renderInputField("City", userData.city, "city", true)}
                  {renderInputField("State", userData.state, "state", true)}
                  {renderInputField("Country", userData.country, "country", true)}
                  {renderInputField("Pincode", userData.pinCode, "pinCode", true)}
                </div>
              </div>
              
              <div className="mt-12 flex flex-row">
                <button 
                  className="w-40 h-10 border border-[#004172] text-[#004172] font-bold font-monospace rounded-md ml-4"
                  onClick={cancelProfile}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {renderConsentModal(termsView, () => setTermsView(false), "Terms of use", consentVersionT?.consentFile)}
      {renderConsentModal(privacyView, () => setPrivacyView(false), "Privacy Policy", consentVersionP?.consentFile)}
    </OurLayouts>
  );
};

export default ProfileScreen;